import { render } from "./FinanciadoresView.vue?vue&type=template&id=3b608388&scoped=true"
import script from "./FinanciadoresView.vue?vue&type=script&lang=js"
export * from "./FinanciadoresView.vue?vue&type=script&lang=js"

import "./FinanciadoresView.vue?vue&type=style&index=0&id=3b608388&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b608388"]])

export default __exports__